package com.alpha.showcase.common.ui.source

import com.alpha.showcase.common.ui.ext.getSimpleMessage
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.background
import androidx.compose.foundation.basicMarquee
import androidx.compose.foundation.clickable
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.outlined.Add
import androidx.compose.material.icons.outlined.DeleteOutline
import androidx.compose.material.icons.outlined.EditNote
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LocalLifecycleOwner
import androidx.lifecycle.compose.currentStateAsState
import com.alpha.showcase.common.ui.confetti.ConfettiController
import com.alpha.showcase.common.ui.confetti.ConfettiType
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.snapshotFlow
import androidx.compose.runtime.withFrameNanos
import androidx.compose.ui.Alignment
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerButtons
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.isSecondaryPressed
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.alpha.showcase.common.networkfile.storage.COLOR_ICON_STORAGE
import com.alpha.showcase.common.networkfile.storage.DROP_BOX
import com.alpha.showcase.common.networkfile.storage.FTP
import com.alpha.showcase.common.networkfile.storage.GOOGLE_DRIVE
import com.alpha.showcase.common.networkfile.storage.GOOGLE_PHOTOS
import com.alpha.showcase.common.networkfile.storage.LOCAL
import com.alpha.showcase.common.networkfile.storage.ONE_DRIVE
import com.alpha.showcase.common.networkfile.storage.SFTP
import com.alpha.showcase.common.networkfile.storage.SMB
import com.alpha.showcase.common.networkfile.storage.StorageSources
import com.alpha.showcase.common.networkfile.storage.WEBDAV
import com.alpha.showcase.common.networkfile.storage.getType
import com.alpha.showcase.common.networkfile.storage.remote.ALBUM
import com.alpha.showcase.common.networkfile.storage.remote.GITEE
import com.alpha.showcase.common.networkfile.storage.remote.GALLERY
import com.alpha.showcase.common.networkfile.storage.remote.GITHUB
import com.alpha.showcase.common.networkfile.storage.remote.GallerySource
import com.alpha.showcase.common.networkfile.storage.remote.IMMICH
import com.alpha.showcase.common.networkfile.storage.remote.MTPHOTO
import com.alpha.showcase.common.networkfile.storage.remote.PEXELS
import com.alpha.showcase.common.networkfile.storage.remote.RSS
import com.alpha.showcase.common.networkfile.storage.remote.S3
import com.alpha.showcase.common.networkfile.storage.remote.TMDB
import com.alpha.showcase.common.networkfile.storage.remote.UNSPLASH
import com.alpha.showcase.common.networkfile.storage.remote.Local
import com.alpha.showcase.common.networkfile.storage.remote.RemoteApi
import com.alpha.showcase.common.cache.GallerySourceMediaStore
import com.alpha.showcase.common.theme.DELETE_COLOR
import com.alpha.showcase.common.ui.dialog.AddGallerySource
import com.alpha.showcase.common.ui.dialog.AddLocalSource
import com.alpha.showcase.common.theme.Dimen
import com.alpha.showcase.common.ui.dialog.DeleteDialog
import com.alpha.showcase.common.ui.dialog.SourceTypeDialog
import com.alpha.showcase.common.ui.settings.SettingsViewModel
import com.alpha.showcase.common.ui.layout.SourceGridLayoutPolicy
import com.alpha.showcase.common.ui.layout.sourceGridLayoutPolicy
import com.alpha.showcase.common.ui.view.DataNotFoundAnim
import com.alpha.showcase.common.ui.view.CircleLoadingIndicator
import com.alpha.showcase.common.ui.vm.UiState
import com.alpha.showcase.common.utils.decodeName
import com.alpha.showcase.common.utils.getIcon
import com.alpha.showcase.common.utils.ToastUtil
import ensureGalleryReadPermissionIfNeeded
import getPlatform
import isWeb
import persistGalleryUriPermission
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import Screen
import androidx.compose.foundation.shape.CircleShape
import androidx.navigation.NavController
import com.alpha.showcase.common.ui.view.rememberMobileHaptic
import com.alpha.showcase.common.utils.encodeBase64UrlSafe
import showcaseapp.composeapp.generated.resources.Res
import showcaseapp.composeapp.generated.resources.add_success
import showcaseapp.composeapp.generated.resources.addSource
import showcaseapp.composeapp.generated.resources.delete
import showcaseapp.composeapp.generated.resources.edit
import showcaseapp.composeapp.generated.resources.gallery_no_new_photos
import showcaseapp.composeapp.generated.resources.loading
import showcaseapp.composeapp.generated.resources.no_photo_selected
import showcaseapp.composeapp.generated.resources.permission_required
import showcaseapp.composeapp.generated.resources.select_folder
import showcaseapp.composeapp.generated.resources.select_photos
import showcaseapp.composeapp.generated.resources.source_name_already_exists

internal fun configTypeForSourceSelection(sourceType: com.alpha.showcase.common.networkfile.storage.StorageType): Int? =
    when (sourceType) {
        SMB, FTP, SFTP, WEBDAV,
        GITHUB, TMDB, GITEE,
        GOOGLE_DRIVE, GOOGLE_PHOTOS, ONE_DRIVE, DROP_BOX,
        UNSPLASH, PEXELS, ALBUM, IMMICH, MTPHOTO,
        S3, RSS -> sourceType.type

        else -> null
    }


@Composable
fun SourceListView(
    navController: NavController,
    viewModel: SourceViewModel = SourceViewModel,
    settingViewModel: SettingsViewModel = SettingsViewModel(),
    firstOpen: Boolean = false,
    onClick: (RemoteApi) -> Unit = {}
) {

    var uiState: UiState<StorageSources> by remember {
        mutableStateOf(UiState.Loading)
    }

    var resumed by remember {
        mutableStateOf(false)
    }

    LaunchedEffect(viewModel) {
        viewModel.sourceListStateFlow.collect {
            uiState = it
        }
    }

    uiState.let {
        when (it) {
            is UiState.Error -> DataNotFoundAnim()
            is UiState.Loading -> CircleLoadingIndicator()
            is UiState.Content -> {
                val sources = it.data.sources.toList()
                SourceGrid(sources = sources, viewModel, navController, onClick)
            }
        }
    }

}

@Composable
private fun SourceGrid(
    sources: List<RemoteApi>,
    viewModel: SourceViewModel,
    navController: NavController,
    onClick: ((RemoteApi) -> Unit)? = null
) {
    var showAddDialog by remember {
        mutableStateOf(false)
    }

    var showLocalAddDialog by remember {
        mutableStateOf(false)
    }

    var showGalleryAddDialog by remember {
        mutableStateOf(false)
    }

    var pendingGallerySourceName by remember {
        mutableStateOf<String?>(null)
    }
    var shouldLaunchGalleryPicker by remember {
        mutableStateOf(false)
    }

    var showOperationDialog by remember {
        mutableStateOf<Operation?>(null)
    }

    var showOperationTargetSource by remember {
        mutableStateOf<RemoteApi?>(null)
    }

    var showConfigDialog by remember {
        mutableStateOf<Int?>(null)
    }

    val scope = rememberCoroutineScope()
    val galleryMediaStore = remember { GallerySourceMediaStore() }
    val performHaptic = rememberMobileHaptic()
    var isAddingSource by remember { mutableStateOf(false) }
    val loadingOverlayInteraction = remember { MutableInteractionSource() }

    val feedback by viewModel.additionFeedback.collectAsState()
    val lifecycleState by LocalLifecycleOwner.current.lifecycle.currentStateAsState()
    LaunchedEffect(feedback.celebrationPending, isAddingSource, showLocalAddDialog, lifecycleState) {
        if (feedback.celebrationPending && !isAddingSource && !showLocalAddDialog &&
            lifecycleState == Lifecycle.State.RESUMED) {
            withFrameNanos { }
            ConfettiController.trigger(ConfettiType.Celebration)
            viewModel.consumeAdditionCelebration()
        }
    }

    val galleryPickerLauncher = rememberGalleryPickerLauncher(
        title = stringResource(Res.string.select_photos),
        onProcessing = { isAddingSource = it },
    ) { selectedFiles ->
        val sourceName = pendingGallerySourceName
        pendingGallerySourceName = null

        if (sourceName.isNullOrBlank()) {
            isAddingSource = false
            return@rememberGalleryPickerLauncher
        }
        if (selectedFiles.isNullOrEmpty()) {
            isAddingSource = false
            ToastUtil.toast(Res.string.no_photo_selected)
            return@rememberGalleryPickerLauncher
        }

        scope.launch {
            isAddingSource = true
            try {
                val medias = withContext(Dispatchers.Default) {
                    selectedFiles.mapNotNull { file ->
                        file.toGalleryMediaInput(sourceName)?.also {
                            persistGalleryUriPermission(it.mediaUri)
                        }
                    }
                }
                if (medias.isEmpty()) {
                    ToastUtil.error(Res.string.no_photo_selected)
                    return@launch
                }

                val source = GallerySource(name = sourceName)
                if (!viewModel.checkDuplicateName(source.name)) {
                    ToastUtil.error(Res.string.source_name_already_exists)
                    return@launch
                }

                val addedSource = runCatching {
                    viewModel.addSourceList(source, reportSuccess = false)
                }.getOrElse {
                    it.printStackTrace()
                    ToastUtil.error(it.message ?: "Failed to add gallery source")
                    false
                }
                if (!addedSource) return@launch

                val inserted = runCatching {
                    galleryMediaStore.addMedias(source.name, medias)
                }.getOrElse {
                    it.printStackTrace()
                    ToastUtil.error(it.message ?: "Failed to save selected photos")
                    0
                }

                if (inserted > 0) {
                    viewModel.reportSourceAdded(source)
                    ToastUtil.success(Res.string.add_success)
                    performHaptic()
                } else {
                    runCatching {
                        viewModel.deleteSource(source)
                    }
                    ToastUtil.toast(Res.string.gallery_no_new_photos)
                }
            } finally {
                isAddingSource = false
            }
        }
    }

    LaunchedEffect(showGalleryAddDialog, shouldLaunchGalleryPicker, pendingGallerySourceName) {
        if (!showGalleryAddDialog && shouldLaunchGalleryPicker && !pendingGallerySourceName.isNullOrBlank()) {
            // Ensure dialog window is fully dismissed before presenting system picker.
            withFrameNanos { }
            delay(120)
            shouldLaunchGalleryPicker = false
            galleryPickerLauncher.launch()
        }
    }

    val listState = rememberLazyGridState()
    val showAddFab by remember {
        derivedStateOf {
            val addItemIndex = sources.size
            val visibleItems = listState.layoutInfo.visibleItemsInfo
            val totalItemsCount = listState.layoutInfo.totalItemsCount
            totalItemsCount > 0 && visibleItems.none { it.index == addItemIndex }
        }
    }
    LaunchedEffect(listState) {
        // Observe scrolling instead of detecting drags: a parent drag detector consumes
        // even tiny mouse movements and cancels the source card's click gesture.
        snapshotFlow { listState.isScrollInProgress }
            .collect { scrolling ->
                if (scrolling) showOperationTargetSource = null
            }
    }


    BoxWithConstraints(
        modifier = Modifier.fillMaxSize()
    ) {
        val layoutPolicy = sourceGridLayoutPolicy(
            isWeb = isWeb(),
            viewportWidthDp = maxWidth.value,
            viewportHeightDp = maxHeight.value,
        )
        LazyVerticalGrid(
            state = listState,
            columns = layoutPolicy.fixedColumnCount?.let(GridCells::Fixed)
                ?: GridCells.Adaptive(layoutPolicy.minimumCellWidthDp.dp),
            contentPadding = PaddingValues(layoutPolicy.contentHorizontalPaddingDp.dp, 8.dp),
            modifier = Modifier
                .fillMaxSize()
                .pointerInput(Unit) {
                    detectTapGestures {
                        showOperationTargetSource = null
                    }
                }
        ) {

            items(sources.size + 1) { index ->

                if (index == sources.size) {
                    AddSourceItem(layoutPolicy = layoutPolicy) {
                        showOperationTargetSource = null
                        showAddDialog = !showAddDialog
                        performHaptic()
                    }
                } else {
                    val source = sources[index]
                    val scaled by derivedStateOf {
                        showOperationTargetSource?.name == source.name
                    }

                    var focused by remember {
                        mutableStateOf(false)
                    }

                    SourceItem(
                        remoteApi = source,
                        showMoreIcon = source.name == showOperationTargetSource?.name,
                        scaled = scaled || focused,
                        layoutPolicy,
                        isNew = feedback.latestSourceName == source.name,
                        onClick = {
                            viewModel.viewModelScope.launch {
                                viewModel.markSourceOpened(source)
                            }
                            onClick?.invoke(source)
                            showOperationTargetSource = null
                        },
                        onLongClick = {
                            showOperationTargetSource = source
                        },
                        onFocusChanged = {
                            focused = it
                        },
                        onMoreIconClick = {
                            when (it) {
                                is Delete -> {
                                    showOperationDialog = it
                                    showOperationTargetSource = source
                                }

                                is Config -> {
                                    showOperationTargetSource = source
                                    showConfigDialog = source.getType()
                                }

                            }
                        })
                }

            }
        }

        if (showAddFab) {
            FloatingActionButton(
                modifier = Modifier
                    .padding(30.dp)
                    .size(60.dp)
                    .align(Alignment.BottomEnd),
                containerColor = MaterialTheme.colorScheme.primary,
                shape = CircleShape,
                onClick = {
                    showOperationTargetSource = null
                    showAddDialog = !showAddDialog
                    performHaptic()
                }
            ) {
                Icon(Icons.Filled.Add, contentDescription = stringResource(Res.string.addSource))
            }
        }

        if (isAddingSource) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.35f))
                    .clickable(
                        interactionSource = loadingOverlayInteraction,
                        indication = null
                    ) {},
                contentAlignment = Alignment.Center
            ) {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    CircularProgressIndicator()
                    Text(
                        text = stringResource(Res.string.loading),
                        color = Color.White
                    )
                }
            }
        }
    }

    if (showAddDialog) {
        SourceTypeDialog {
            showAddDialog = false
            it?.apply {
                when (this) {
                    is LOCAL -> {
                        showLocalAddDialog = true
                    }

                    GALLERY -> {
                        showGalleryAddDialog = true
                    }

                    else -> {
                        showConfigDialog = configTypeForSourceSelection(this)
                    }
                }

            }
        }
    }

    if (showOperationDialog == Delete) {
        showOperationTargetSource?.apply {
            DeleteDialog(
                deleteName = name.decodeName(),
                onConfirm = {
                    scope.launch {
                        try {
                            if (viewModel.deleteSource(this@apply)) {
                                showOperationTargetSource = null
                                showOperationDialog = null
                            }
                        } catch (error: kotlinx.coroutines.CancellationException) {
                            throw error
                        } catch (error: Exception) {
                            ToastUtil.error("${name.decodeName()}: ${error.getSimpleMessage()}")
                        }
                    }
                },
                onCancel = {
                    showOperationTargetSource = null
                    showOperationDialog = null
                },
                onDismiss = {
                    showOperationTargetSource = null
                    showOperationDialog = null
                })
        }
    }

    showConfigDialog?.let { type ->
        val sourceNameArg = showOperationTargetSource?.name?.encodeBase64UrlSafe().orEmpty()
        val route = if (sourceNameArg.isNotBlank()) {
            "${Screen.Config.route}/$type?sourceName=$sourceNameArg"
        } else {
            "${Screen.Config.route}/$type"
        }
        LaunchedEffect(route) {
            navController.navigate(route)
            showConfigDialog = null
            showOperationTargetSource = null
        }
    }


    if (showLocalAddDialog) {
        var name by remember {
            mutableStateOf("")
        }

        val fileLauncher = rememberSourceDirectoryPicker(
            title = stringResource(Res.string.select_folder)
        ) { directory ->
            if (directory == null) return@rememberSourceDirectoryPicker

            val selectedPath = directory.takeIf { it.isNotBlank() }

            if (selectedPath.isNullOrBlank()) {
                ToastUtil.error("Failed to read selected folder")
                return@rememberSourceDirectoryPicker
            }

            scope.launch {
                isAddingSource = true
                try {
                    val added = runCatching {
                        viewModel.addSourceList(
                            Local(
                                name = name,
                                path = selectedPath,
                                platform = getPlatform().platform.platformName
                            )
                        )
                    }.getOrElse { error ->
                        error.printStackTrace()
                        ToastUtil.error(error.message ?: "Failed to add local source")
                        false
                    }

                    if (added) {
                        ToastUtil.success(Res.string.add_success)
                        performHaptic()
                        showLocalAddDialog = false
                    }
                } finally {
                    isAddingSource = false
                }
            }
        }

        AddLocalSource(
            onCancelClick = {
                showLocalAddDialog = false
            },
            onConfirmClick = {
                name = it
                scope.launch {
                    fileLauncher.launch()
                }

            }
        )

    }

    if (showGalleryAddDialog) {
        AddGallerySource(
            onCancelClick = {
                showGalleryAddDialog = false
                pendingGallerySourceName = null
                shouldLaunchGalleryPicker = false
            },
            onConfirmClick = { name ->
                if (!viewModel.checkDuplicateName(name)) {
                    ToastUtil.error(Res.string.source_name_already_exists)
                    return@AddGallerySource
                }
                if (!ensureGalleryReadPermissionIfNeeded()) {
                    pendingGallerySourceName = null
                    ToastUtil.toast(Res.string.permission_required)
                    return@AddGallerySource
                }
                pendingGallerySourceName = name
                showGalleryAddDialog = false
                shouldLaunchGalleryPicker = true
            }
        )
    }
}


private val MORE_OPERATION by lazy { listOf(Config, Delete) }

@Composable
private fun SourceItem(
    remoteApi: RemoteApi,
    showMoreIcon: Boolean = false,
    scaled: Boolean = false,
    layoutPolicy: SourceGridLayoutPolicy,
    isNew: Boolean = false,
    onFocusChanged: ((Boolean) -> Unit)? = null,
    onClick: () -> Unit,
    onLongClick: () -> Unit = {},
    onMoreIconClick: (Operation) -> Unit = {}
) {

    val moreChoice = remember {
        mutableStateOf(if (remoteApi is Local) listOf(Delete) else MORE_OPERATION)
    }

    Column {
        SourceItemBackground(
            layoutPolicy = layoutPolicy,
            scaled = scaled,
            onFocusChanged = {
                onFocusChanged?.invoke(it)
            },
            onClick = {
                onClick.invoke()
            },
            onLongClick = {
                onLongClick.invoke()
            }) {

            Box {
                Icon(
                    painter = painterResource(remoteApi.getIcon()),
                    contentDescription = remoteApi.name,
                    modifier = Modifier
                        .padding(20.dp)
                        .fillMaxSize(),
                    tint = if (remoteApi.getIcon() in COLOR_ICON_STORAGE) Color.Unspecified else LocalContentColor.current
                )

                if (showMoreIcon) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(DELETE_COLOR)
                            .wrapContentHeight()
                            .align(Alignment.BottomCenter),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.Bottom
                    ) {

                        moreChoice.value.forEach {
                            when (it) {
                                is Config -> {
                                    Icon(
                                        Icons.Outlined.EditNote,
                                        contentDescription = stringResource(Res.string.edit),
                                        tint = MaterialTheme.colorScheme.background,
                                        modifier = Modifier
                                            .clickable {
                                                onMoreIconClick.invoke(Config)
                                            }
                                            .padding(3.dp)
                                            .weight(1f)
                                    )
                                }

                                is Delete -> {
                                    Icon(
                                        Icons.Outlined.DeleteOutline,
                                        contentDescription = stringResource(Res.string.delete),
                                        tint = MaterialTheme.colorScheme.background,
                                        modifier = Modifier
                                            .clickable {
                                                onMoreIconClick.invoke(Delete)
                                            }
                                            .padding(3.dp)
                                            .weight(1f)
                                    )
                                }

                            }
                        }
                    }
                }
            }


        }
        Row(
            modifier = Modifier.padding(5.dp).align(Alignment.CenterHorizontally),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(6.dp),
        ) {
            if (isNew) {
                Box(Modifier.size(6.dp).background(MaterialTheme.colorScheme.primary, CircleShape))
            }
            Text(
                text = remoteApi.name.decodeName(),
                fontSize = 14.sp,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Center,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(1f, fill = false).basicMarquee()
            )
        }
    }

}

@Composable
private fun AddSourceItem(layoutPolicy: SourceGridLayoutPolicy, onClick: () -> Unit) {
    var scaled by remember {
        mutableStateOf(false)
    }
    Column {
        SourceItemBackground(
            layoutPolicy = layoutPolicy,
            scaled = scaled,
            onFocusChanged = {
                scaled = it
            },
            onClick = {
                onClick.invoke()
                scaled = false
            }) {
            Icon(
                Icons.Outlined.Add,
                contentDescription = stringResource(Res.string.addSource),
                modifier = Modifier
                    .padding(Dimen.spaceXL)
                    .fillMaxSize()
            )
        }
        Text(
            text = stringResource(Res.string.addSource),
            fontSize = 14.sp,
            overflow = TextOverflow.Ellipsis,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Center,
            modifier = Modifier
                .padding(5.dp)
                .align(Alignment.CenterHorizontally)
        )
    }

}

@OptIn(ExperimentalFoundationApi::class, ExperimentalComposeUiApi::class)
@Composable
private fun SourceItemBackground(
    layoutPolicy: SourceGridLayoutPolicy,
    scaled: Boolean = false,
    onFocusChanged: ((Boolean) -> Unit)? = null,
    onClick: (() -> Unit)? = null,
    onLongClick: (() -> Unit)? = null,
    content: @Composable ColumnScope.() -> Unit
) {

    val scale = animateFloatAsState(if (scaled) 1.05f else 1f)
    val pressedInteractionSource = remember { MutableInteractionSource() }

    ElevatedCard(
        modifier = Modifier
            .padding(layoutPolicy.itemPaddingDp.dp)
            .fillMaxWidth()
            .onFocusChanged {
                onFocusChanged?.invoke(it.isFocused)
            }
            .scale(scale.value)
            .then(
                layoutPolicy.cardAspectRatio?.let { Modifier.aspectRatio(it) }
                    ?: Modifier.height(layoutPolicy.fixedCardHeightDp.dp)
            )
            .shadow(2.dp, CardDefaults.elevatedShape)
//      .onClick(
//        matcher = PointerMatcher.mouse(PointerButton.Secondary), // Right Mouse Button
//        onLongClick = {
//          onLongClick?.invoke()
//        },
//        onClick = {
//          onLongClick?.invoke()
//        }
//      )
            .combinedClickable(
                interactionSource = pressedInteractionSource,
                indication = LocalIndication.current,
                onClick = onClick ?: {},
                onLongClick = {
                    onLongClick?.invoke()
                })
            .pointerInput(Unit) {
                awaitPointerEventScope{
                    while (true) {
                        val event = awaitPointerEvent(PointerEventPass.Final)
                        when (event.type) {
                            PointerEventType.Enter -> {
                                onFocusChanged?.invoke(true)
                            }

                            PointerEventType.Exit -> {
                                onFocusChanged?.invoke(false)
                            }

                            PointerEventType.Press -> {
                                if (event.buttons.isSecondaryPressed) {
                                    onLongClick?.invoke()
                                }
                            }
                        }
                    }
                }
            }
//      .onPointerEvent(PointerEventType.Enter) {
//        onFocusChanged?.invoke(true)
//      }.onPointerEvent(PointerEventType.Exit) {
//        onFocusChanged?.invoke(false)
//      }
        ,
//    onClick = onClick?: {},
        content = content
    )
}
